module.exports = __webpack_public_path__ + "static/media/dark_SocialsInOne_logo.a52db4d5.png";